import { BottomNavigation, BottomNavigationAction, Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { MARGIN_GAP } from "../lib/constants.js";

export default function TabMenu({ tabButtons = [] }) {
  const { pathname } = useLocation();
  const currentContent = pathname.split("/")[2];

  return (
    <Box mb={MARGIN_GAP}>
      <BottomNavigation
        value={currentContent}
        showLabels
        sx={{
          background: "none",
          borderBottom: 1,
          borderColor: "divider",
          justifyContent: "flex-start",
          "& .MuiBottomNavigationAction-root": {
            color: "primary.main",
            "&.Mui-selected": {
              borderBottom: "2px solid",
              borderColor: "divider",
              color: "secondary.main",
            },
          },
          "& .MuiBottomNavigationAction-label": {
            fontSize: (theme) => theme.typography.body1,
            "&.Mui-selected": {
              fontSize: (theme) => theme.typography.body1,
            },
          },
        }}
      >
        {tabButtons.map((button, index) => (
          <BottomNavigationAction
            component={Link}
            key={index}
            label={button.label}
            to={button.route}
            value={button.route}
          />
        ))}
      </BottomNavigation>
    </Box>
  );
}
